import { BaseQueryBuilder } from './BaseQueryBuilder';
import { SearchRequest } from './SearchRequest';
import { SearchResponseResponseBuilder } from './SearchResponseResponseBuilder';

export class SearchQueryBuilder extends BaseQueryBuilder {
    constructor(responseBuilder: SearchResponseResponseBuilder, searchRequest: SearchRequest) {
        super('search', responseBuilder);
        if (searchRequest) this.args.push(this.addVariable('SearchRequest', 'SearchRequest', true, searchRequest));
    }
}
